import React, { useState } from 'react';
import styled from 'styled-components';
import { Col, Row } from 'react-bootstrap';
import Title from '@/components/common/ui/text/Title';
import useContainerOffset from '@/components/hooks/useContainerOffset';
import { Img } from '@/components/common/ui/images/Img';
import { theme } from '@/components/features/theme/theme';
import reactHtmlParser from 'react-html-parser';

const SustainabilitySingle = ({ item, subtitle, images, des }) => {

	const offset = useContainerOffset('.container');
	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	return (
		<StyledSustainabilitySingle offset={offset}>
			<Row className={'sustainability'}>
				<Col md={6} className={'sustainability__left'}>
					<div className={'sustainability__left__data'}>
						<Title animClass={'anim-text'} tag={'h2'} text={subtitle} color={'#fff'} />
						{reactHtmlParser(des)}
					</div>
				</Col>
				<Col md={6} className={'sustainability__right '}>
					<div className="image-wrapper">
						<Img src={images} alt={subtitle ? subtitle.replace(/<[^>]*>/g, '') : 'Sustainability initiative'} />
					</div>
				</Col>
			</Row>
		</StyledSustainabilitySingle>
	);
};
const StyledSustainabilitySingle = styled.div`
    .sustainability {
        margin: 0;

        &__left {
            background-color: #D80028;
            margin-left: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-bottom: 80px;

            &__data {
                position: relative;
                padding-right: ${props => props.offset}px;
                padding-left: ${props => props.offset}px;

                margin-top: 0;

                @media (max-width: 1365px) {
                    margin-top: 80px;
                }

                @media (max-width: 767px) {
                    margin-top: 180px;
                }

                ul {
                    position: relative;
                    left: unset;
                    top: unset;
                }

                .title {
                    z-index: 5;

                    h2 {
                        font-size: ${theme.fontSizes.h2};
                        font-family: ${theme.fonts.heading};
                        font-weight: ${theme.fontWeights.regular};
                        line-height: ${theme.lineHeights.h2};
                        letter-spacing: ${theme.letterSpacing.h2};

                        @media (max-width: 1300px) {
                            font-size: ${theme.fontSizes.h3} !important;
                            font-weight: ${theme.fontWeights.regular} !important;
                            line-height: ${theme.lineHeights.h3} !important;
                            letter-spacing: ${theme.letterSpacing.h2} !important;
                        }
                        @media (max-width: 992px) {
                            font-size: ${theme.fontSizes.h3} !important;
                            font-weight: ${theme.fontWeights.regular} !important;
                            line-height: ${theme.lineHeights.h3} !important;
                            letter-spacing: ${theme.letterSpacing.h3} !important;
                        }
                    }

                }


                p {
                    margin-top: 20px;
                    font-weight: 400;
                    font-size: 1rem; /* 16px */
                    line-height: 1.5rem; /* 24px */
                    letter-spacing: 0; /* 0% */
                    color: white;
                }

                .text {
                    margin-bottom: 40px;
                    color: #f9f9f9;
                }
            }
        }

        &__right {
            position: relative;
            padding: 0;

            .image-wrapper {
                position: relative;
                padding-top: calc(660 / 670 * 100%);
            }

            img {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
                object-fit: cover;
            }
        }
    }

`;


export default SustainabilitySingle;